import React, { createContext, useState, useEffect } from 'react';

export const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {
    const [deviceInfo, setDeviceInfo] = useState(getDeviceInfo());

    useEffect(() => {
        const handleResize = () => setDeviceInfo(getDeviceInfo());
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <DeviceContext.Provider value={deviceInfo}>
            {children}
        </DeviceContext.Provider>
    );
};

const getDeviceInfo = () => {
    const width = window.innerWidth;
    const isResponsive = width < 992;
    return {
        isResponsive,
        isMobile: width < 768
    };
};
